import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const CONFIG = {
  appName: 'CatchMoments',
  /** 정본은 package.json — next.config 가 빌드 때 꼬리(-preview·-dev)를 붙여 env 로 준다 */
  appVersion: process.env.NEXT_PUBLIC_APP_VERSION ?? packageJson.version,
  serverUrl: process.env.NEXT_PUBLIC_SERVER_URL ?? '',
  channelTalkUrl: process.env.NEXT_PUBLIC_CHANNEL_TALK_URL ?? '',
  assetsDir: process.env.NEXT_PUBLIC_ASSETS_DIR ?? '',
  isStaticExport: JSON.parse(process.env.BUILD_STATIC_EXPORT ?? 'false'),

  // Layout
  layout: {
    maxWidth: '1720px',
  },
  /**
   * Auth
   * @method jwt | amplify | firebase | supabase | auth0
   */

  stage: process.env.STAGE ?? '',

  app: {
    url: process.env.NEXT_PUBLIC_APP_URL ?? '',
  },


  auth: {
    method: 'firebase',
    skip: false,
    redirectPath: paths.service.root,
    kakaoApp: {
      /** OAuth `client_id`는 서버 env `KAKAO_APP_API_KEY`(+ 있으면 `KAKAO_CLIENT_SECRET`) — `/api/auth/kakao/authorize` · `/auth/callback/kakao`(`src/server/auth/kakao-login.ts`) 에서만 사용 */
      jskey: process.env.NEXT_PUBLIC_KAKAO_APP_JS_KEY ?? '',
    },
  },
  firebase: {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY ?? '',
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID ?? '',
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET ?? '',
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID ?? '',
    appId: process.env.NEXT_PUBLIC_FIREBASE_APPID ?? '',
    measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID ?? '',
  },
  aws: {
    gateway: process.env.NEXT_PUBLIC_AWS_GATEWAY_HOST ?? '',
  },

  slack: {
    clientId: process.env.NEXT_PUBLIC_SLACK_CLIENT_ID ?? '',
    clientSecret: process.env.SLACK_CLIENT_SECRET ?? '',
  },

  /**
   * MCP 커넥터.
   *
   * ⚠️ `oauthSecret` 은 **서버에서만 읽는다** — 브라우저로 내려가면 누구나 남의 워크스페이스를
   *   서명해 토큰을 받아 간다. `NEXT_PUBLIC_` 접두를 붙이지 마라.
   * ⚠️ 비어 있으면 연결 화면이 「준비 중」으로 서고 서명 창구는 503 이다(꺼진 상태가 기본).
   */
  mcp: {
    url: process.env.NEXT_PUBLIC_MCP_URL ?? '',
    oauthSecret: process.env.MCP_OAUTH_SECRET ?? '',
  },

  serviceApiKey: {
    channelTalk: process.env.NEXT_PUBLIC_CHANNEL_IO_API_KEY ?? '',
    googleGA: process.env.NEXT_PUBLIC_GA_ID ?? '',
  },

  subscription: {
    payple: {
      scriptUrl: process.env.NEXT_PUBLIC_PAYPLE_PAYMENTS_SCRIPT_URL ?? '',
      cstId: process.env.NEXT_PUBLIC_PAYPLE_PAYMENTS_CST_ID ?? '',
      referrerUrl: process.env.NEXT_PUBLIC_PAYPLE_PAYMENTS_REFERRER_URL ?? '',
      clientKey: process.env.NEXT_PUBLIC_PAYPLE_PAYMENTS_CLIENT_KEY ?? '',
    },
  },
};
